// Global components.
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Redux.
import { connect } from "react-redux";
import { getMenuItems } from '../../actions/menuActions';

// Styles.
import '../../styles/components/global/MainMenu.scss';

class Header extends Component {
  componentDidMount() {
    this.props.getMenuItems();
  }

  render() {
    const { menuItems } = this.props;

    return (
      <div className="d-flex justify-content-between">
        { menuItems.map(menuItem => {
          return (
            <Link
              key={ menuItem.key }
              to={ menuItem.relative }
            >
              { menuItem.title }
            </Link>
          )
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    menuItems: state.menuItems.items
  };
}

export default connect(mapStateToProps, { getMenuItems })(Header);
